import "./App.scss";
import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { motion } from "framer-motion";
import SignupForm from "./SignupForm";
import ThanksMsg from "./ThanksMsg";

function App() {
  const [emailData, setEmailData] = useState("");
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 2 }}
            >
              <SignupForm setEmailData={setEmailData} />
            </motion.div>
          }
        ></Route>
        <Route path="/Thanks" element={<ThanksMsg email={emailData} />}></Route>
      </Routes>
    </div>
  );
}

export default App;

//10/1,9/27 ,9/28
